import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/transfer-by-serials', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/transfer-by-serials/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/v1/transfer-by-serials/${data.stock_transfer_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/transfer-by-serials/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const updateStatus = data => {
  return httpClient
    .put(
      `/api/v1/transfer-by-serials/update-status/${data.stock_transfer_id}`,
      data
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const fromWarehouse = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials/from-warehouses', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const toWarehouse = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials/to-warehouses', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const product = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uom = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials/uom', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const branch = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials/branches', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const printPdf = (Options = {}) => {
  return httpClient
    .get('/api/v1/stock-transfers/print-pdf', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productSearch = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials/search-products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSerialStatus = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials/serial-status', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getCategoryAvailable = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials/category-available', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getProductAvailable = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials/product-available', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productAvailableSearch = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials/product-available-search', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getNewSerialByQty = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials/new-serial-by-quantity', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const sysQty = (Options = {}) => {
  return httpClient
    .get('/api/v1/transfer-by-serials/system-qty/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const checkReceiveMonthDiffMonthTransfer = data => {
  return httpClient
    .post(
      '/api/v1/transfer-by-serials/check-receive-month-diff-month-transfers',
      data
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exportExcel = attributes => {
  return httpClient
    .post('/api/v1/transfer-by-serials/export-excel', attributes, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  toWarehouse,
  product,
  uom,
  branch,
  updateStatus,
  printPdf,
  productSearch,
  getSerialStatus,
  getCategoryAvailable,
  getProductAvailable,
  productAvailableSearch,
  getNewSerialByQty,
  sysQty,
  fromWarehouse,
  checkReceiveMonthDiffMonthTransfer,
  exportExcel
}
